import { Link } from "react-router-dom";
import {
  FaYoutube,
  FaInstagram,
  FaTiktok,
  FaFacebookF,
  FaGasPump,
} from "react-icons/fa6";
import "./Footer.scss";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  // 🔥 THE FIX: Industry standard user privacy choice revocation handler
  const handleOpenCookiePreferences = () => {
    localStorage.setItem("showCookiePreferencesModal", "true");
    window.location.reload(); // Refresh viewport to trigger our lazy useState initialization hook!
  };

  return (
    <footer className="footer-chassis">
      <div className="footer-container">
        {/* COLUMN 1: BRAND LOGO & MISSION MANIFEST */}
        <div className="footer-block footer-block--brand">
          <Link to="/" className="footer-logo">
            <img
              src="https://sunrisebucket.s3.us-east-2.amazonaws.com/logo.PNG"
              alt="Mini Miles Adventures"
            />
          </Link>
          <p className="brand-statement">
            Following quiet backroads, national parks, and unexpected places
            across the country—all captured from the unique, slow-lane
            perspective of a small car.
          </p>

          {/* SOCIAL MEDIA MATRIX ICONS ROW */}
          <div className="social-links-matrix">
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon social-icon--youtube"
              aria-label="Subscribe on YouTube"
            >
              <FaYoutube />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon social-icon--instagram"
              aria-label="Follow on Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://tiktok.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon social-icon--tiktok"
              aria-label="Follow on TikTok"
            >
              <FaTiktok />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon social-icon--facebook"
              aria-label="Follow on Facebook"
            >
              <FaFacebookF />
            </a>
          </div>
        </div>

        {/* COLUMN 2: INTERNAL LINKS EXPEDITION ROUTES */}
        <div className="footer-block">
          <h3>Expedition Routes</h3>
          <nav className="footer-nav-list">
            <Link to="/journeys">Journeys Feed</Link>
            <Link to="/watch">Watch Videos</Link>
            <Link to="/roadnotes">Journal Notes</Link>
            <Link to="/gallery">Photo Gallery</Link>
          </nav>
        </div>

        {/* COLUMN 3: INTERNAL LINKS CHANNEL COORDNATES */}
        <div className="footer-block">
          <h3>Channel Intel</h3>
          <nav className="footer-nav-list">
            {/* <Link to="/blog">The Blog Hub</Link> */}
            <Link to="/about">Our Story</Link>
            <Link to="/shop">Gear Shop</Link>
            <Link to="/contact">Drop a Line</Link>
          </nav>
        </div>

        {/* COLUMN 4: CALL TO ACTION CO-PILOT PANEL */}
        <div className="footer-block footer-block--cta">
          <h3>Support the Drive</h3>
          <p>
            Help keep the small car moving toward new horizons and quiet towns.
          </p>
          <Link to="/fuel-up" className="navbar__fuel-btn footer-fuel-btn">
            <span>
              <FaGasPump />
            </span>
            Fuel the Journey
          </Link>
        </div>
      </div>

      {/* LOWER COMPACT LEGAL FINISH BASE BAR */}
      <div className="footer-sub-bar">
        <div className="sub-bar-content">
          <span>
            {" "}
            &copy; {currentYear} Mini Miles Adventures. All Rights Logged.{" "}
          </span>

          <div className="legal-links-row">
            <Link to="/legal/terms">Terms & Conditions</Link>
            <span className="divider">|</span>
            <Link to="/legal/privacy">Privacy Policy</Link>
            <span className="divider">|</span>
            <Link to="/legal/return-cancellation">Return & Cancellation</Link>
            <span className="divider">|</span>

            {/* 🔥 NEW: Clean interactive cookie revocation button link element */}
            <button
              type="button"
              className="footer-cookie-settings-link"
              onClick={handleOpenCookiePreferences}
              style={{
                background: "none",
                border: "none",
                color: "inherit",
                font: "inherit",
                padding: 0,
                cursor: "pointer",
                textDecoration: "none",
              }}
            >
              Cookie Settings
            </button>
            <span className="divider">|</span>

            <Link to="/legal/safety">Safety Tips</Link>
          </div>

          {/* REQUIRED AMAZON ASSOCIATE LEGAL DISCLOSURE */}
          <p className="amazon-affiliate-disclaimer">
            *As an Amazon Associate I earn from qualifying purchases. Mini Miles
            Adventures links to select retailer networks to help support our
            journey at no extra cost to you.
          </p>
        </div>
      </div>
    </footer>
  );
}
